export default __webpack_public_path__ + "static/media/pings-and-webcam.400454d5.png";